import { useEffect, useState } from 'react';
import { resolveUrl, getCachedUrl, onInvalidate } from '../services/storageUrls.js';

export function useStorageUrl(key) {
  const [state, setState] = useState(() => ({ key, url: getCachedUrl(key) }));
  useEffect(() => {
    let cancelled = false;
    let revision = 0;
    const update = () => {
      const current = ++revision;
      resolveUrl(key).then((url) => {
        if (!cancelled && current === revision) setState({ key, url });
      });
    };
    const unsubscribe = key ? onInvalidate(key, update) : () => {};
    update();
    return () => { cancelled = true; unsubscribe(); };
  }, [key]);
  return state.key === key ? state.url : getCachedUrl(key);
}

export function useStorageUrls(keys) {
  const keySet = JSON.stringify([...new Set((keys || []).filter(Boolean))]);
  const [state, setState] = useState({ keySet: '', urls: {} });
  useEffect(() => {
    const currentKeys = JSON.parse(keySet);
    const revisions = new Map();
    let cancelled = false;
    const update = (key) => {
      const revision = (revisions.get(key) || 0) + 1;
      revisions.set(key, revision);
      resolveUrl(key).then((url) => {
        if (cancelled || revisions.get(key) !== revision) return;
        setState((previous) => ({ keySet, urls: { ...(previous.keySet === keySet ? previous.urls : {}), [key]: url } }));
      });
    };
    const unsubscribe = currentKeys.map((key) => onInvalidate(key, () => update(key)));
    currentKeys.forEach(update);
    return () => { cancelled = true; unsubscribe.forEach((stop) => stop()); };
  }, [keySet]);
  return Object.fromEntries(JSON.parse(keySet).map((key) => [key, state.keySet === keySet ? state.urls[key] ?? getCachedUrl(key) : getCachedUrl(key)]));
}

export default useStorageUrl;
